import { withStyles } from '@material-ui/core';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';

import theme from '../../../themes/theme';
import { selectStrings } from '../../../utils/constants';

const styles = {
    autocompleteField: {
        margin: `${theme.margins.textField.top} ${theme.margins.textField.all}`,
        flexGrow: 1,
        minWidth: 350,
        '& div.MuiInputBase-root': {
            paddingBottom: 2,
        },
        '& div.MuiInputBase-root .MuiInputBase-input': {
            marginTop: -4,
            paddingBottom: 8,
        },
        '& label.MuiInputLabel-root': {
            marginTop: -6,
        },
    },
    boxItem: {
        width: 550,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
};

const FavoriteReportsList = ({
    classes: { autocompleteField, boxItem },
    favoriteReports,
    loadFavoriteReport,
    selectedFavoriteReport,
    setSelectedFavoriteReport,
}) => {
    const DROPDOWN_LIST_HEIGHT = 400;

    const onChange = (_event, newValue) => {
        setSelectedFavoriteReport(newValue);
        newValue && loadFavoriteReport(newValue);
    };

    return (
        <Autocomplete
            className={autocompleteField}
            options={favoriteReports}
            getOptionLabel={option => option.name}
            value={selectedFavoriteReport || null}
            onChange={onChange}
            renderInput={params => (
                <TextField
                    {...params}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    label="Ulubione zestawienia"
                    placeholder="Wybierz ulubione zestawienie z listy..."
                    variant="standard"
                />
            )}
            noOptionsText={selectStrings.noOptionsAvailable}
            clearText={selectStrings.clearText}
            closeText={selectStrings.closeText}
            openText={selectStrings.openText}
            ListboxProps={{
                style: {
                    maxHeight: DROPDOWN_LIST_HEIGHT,
                },
            }}
            renderOption={(props, option, { inputValue }) => {
                const { key, ...optionProps } = props;
                const optionKey = option.id ?? key;
                const matches = match(option.name, inputValue, {
                    requireMatchAll: true,
                });
                const parts = parse(option.name, matches);
                const optionContent = (
                    <div className={boxItem}>
                        {parts.map((part, index) => (
                            <span
                                key={index}
                                style={{
                                    fontWeight: part.highlight
                                        ? theme.font.weight.bold
                                        : theme.font.weight.normal,
                                }}>
                                {part.text}
                            </span>
                        ))}
                    </div>
                );

                if (option.description) {
                    return (
                        <Tooltip
                            title={<span style={{ whiteSpace: 'pre-line' }}>{option.description}</span>}
                            arrow
                            placement="left"
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        fontSize: '0.85rem',
                                    },
                                },
                            }}
                            key={optionKey}>
                            <li {...optionProps}>{optionContent}</li>
                        </Tooltip>
                    );
                }

                return (
                    <li {...optionProps} key={optionKey}>
                        {optionContent}
                    </li>
                );
            }}
        />
    );
};

export default withStyles(styles)(FavoriteReportsList);
